import { useQuery } from "react-query";
import QUERY_KEYS from "../queryKeys";
import {
  getAthleteDetails,
  getAthleteHighlights,
  getAthletePosts,
  getAthleteStats,
} from "./queryFunctions";
import commonConfig from "../config";

export const useAthleteProfile = (ath_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.ATHLETE_DETAILS, ath_id],
    queryFn: () => getAthleteDetails({ ath_id }),
    ...commonConfig,
    ...config,
  });

export const useAthleteStats = (ath_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.ATHLETE_STATS, ath_id],
    queryFn: () => getAthleteStats({ ath_id }),
    ...commonConfig,
    ...config,
  });

export const useAthleteHighlights = (
  page,
  limit,
  geo_lat,
  geo_long,
  ath_id,
  config = {}
) =>
  useQuery({
    queryKey: [
      QUERY_KEYS.ATHLETE_HIGHLIGHTS,
      page,
      limit,
      geo_lat,
      geo_long,
      ath_id,
    ],
    queryFn: () =>
      getAthleteHighlights({ page, limit, geo_lat, geo_long, ath_id }),
    ...commonConfig,
    ...config,
  });

export const useAthletePosts = (
  page,
  limit,
  geo_lat,
  geo_long,
  ath_id,
  config = {}
) =>
  useQuery({
    queryKey: [
      QUERY_KEYS.ATHLETE_POSTS,
      page,
      limit,
      geo_lat,
      geo_long,
      ath_id,
    ],
    queryFn: () => getAthletePosts({ page, limit, geo_lat, geo_long, ath_id }),
    ...commonConfig,
    ...config,
  });
